module.exports = __webpack_public_path__ + "static/media/clockCal.51c8df50.svg";